import type { SVGProps } from 'react'
const SvgSyComment = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M5.172 6.172C4 7.343 4 9.229 4 13v5.586c0 .89 1.077 1.337 1.707.707l2.147-2.147a.5.5 0 0 1 .154-.127c.046-.019.097-.019.2-.019H14c1.864 0 2.796 0 3.53-.304a4 4 0 0 0 2.165-2.165C20 13.796 20 12.864 20 11s0-2.796-.304-3.53a4 4 0 0 0-2.165-2.166C16.796 5 15.864 5 14 5h-2C8.229 5 6.343 5 5.172 6.172"
			clipRule="evenodd"
		/>
		<path d="M8.5 9a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm0 3a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5z" />
	</svg>
)
export default SvgSyComment
